export const alertsConstants = {
    errors: {
        fetchFailed: "Failed to load alerts.",
        countFailed: "Failed to load alerts count.",
        fetchDetailFailed: "Failed to load alert details.",
        createFailed: "Failed to create alert.",
        updateFailed: "Failed to update alert.",
        deleteFailed: "Failed to delete alert.",
        acknowledgeFailed: "Failed to acknowledge alert.",
        doneFailed: "Failed to mark alert as done.",
    },
    messages: {
        createSuccess: "Alert created successfully.",
        updateSuccess: "Alert updated successfully.",
        deleteSuccess: "Alert deleted successfully.",
        acknowledgeSuccess: "Alert acknowledged.",
        doneSuccess: "Alert marked as done.",
    },
};
